module.exports = __webpack_public_path__ + "static/media/header2.fd758b57.jpg";